import {
    Show,
    TextInput,
    useTranslate,
    useRecordContext,
    required,
    SelectInput,
    ReferenceInput,
    Create,
    TextField,
    ReferenceField,
    Pagination,
    Datagrid,
    ReferenceManyField,
    SimpleForm,
    useRefresh,
    RichTextField,
    useGetList,
    SimpleShowLayout,
    AutocompleteInput,
    DateInput,
    useDataProvider,
    FormDataConsumer,
    TopToolbar,
    DataProviderContext,
    Loading,
    ListContextProvider,
    useList,
    FunctionField,
} from 'react-admin';

import ThumbnailField from '../../common/ThumbnailField';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { BASE_URL_GO } from '../../common/constants';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { LinearProgress, Typography } from '@mui/material';
import { NoDataSection } from '../../common/NoDataSection';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import { Ecom_Products, Users } from '../../custom';
import { SoftDeleteWithDialogAction } from '../../common/SoftDeleteWithDialogAction';
import { addDays, format } from 'date-fns';
import OrderField from '../../common/OrderField';
import { Today } from '@mui/icons-material';
import { createCustomGoDataProvider, goApi } from '../../services';
import AssignEcomProductModal from '../../common/ecom-products/AssignEcomProductModal';
import { useAssignRefresh } from '../../hooks/useAssignRefresh';
import UserField from '../../common/UserField';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';
import AssignedUserList from '../../common/ecom-products/AssignedUserList';
// ====================== Start Assign Product ===================================
export const studentProfileRender = (choice: any) =>
    `${choice.firstName} ${choice.lastName || ''} | ${choice.phone || 'No Phone'} | ${choice.email || 'No Email'
    }`;

export const filterToQueryStudent = (searchText: any) => ({
    phone: `${searchText}`,
});

export const EndsOnTime = (props: any) => {
    const record = useRecordContext<any>();
    if (!record) return null;
    const isExpired = record.endsOn && new Date(record.endsOn) < new Date();
    return (
        <div
            className="flex flex-col text-sm space-y-1"
            style={{ background: isExpired ? 'red' : 'transparent' }}
        >
            {record.endsOn && (
                <div className="flex items-center space-x-2">
                    <div className="whitespace-nowrap">
                        {format(new Date(record.endsOn), 'dd-MMM-yyyy hh:mm a')}
                    </div>
                </div>
            )}
        </div>
    );
};

EndsOnTime.defaultProps = {
    source: 'ends_on',
    label: 'Ends On',
};

const CustomListActions = () => <></>;

const ProductShow = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [studentQuery, setStudentQuery] = useState('');
    const { refreshKey, handleAssignSuccess } = useAssignRefresh();
    const params = useParams();

    const handleTabClick = (index: any) => {
        setActiveTab(index);
    };
    let { productId, categoryId } = useParams();
    if (!productId) {
        return <LoadingSection />;
    }
    const {
        data: ProductData,
        isLoading,
        error,
    } = useQuery(
        ['ecom_categories', categoryId],
        () =>
            goApi.get(`/ecom/categories/${categoryId}`),
        {
            enabled: !!categoryId,
        },
    );
    const baseDataProvider = useDataProvider();
    const customDataProvider = React.useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'ecom_products', apiEndpoint: '/ecom/products' },
                { resource: 'ecom_categories', apiEndpoint: '/admin/v1/ecom/categories' },
            ]),
        [baseDataProvider],
    );
    const { refetch } = useQuery( ['ecom_products', productId], () => goApi.get(`/ecom/products/${productId}`), {
        enabled: !!productId,
    });

    const isEbook = ProductData?.data?.name === 'E-Books';

    const tabData = [
        {
            label: 'Details',
            content: (
                <div className="py-8">
                    <DataProviderContext.Provider value={customDataProvider}>
                        <Show
                            actions={<CustomListActions />}
                            title={<Title />}
                            resource="ecom_products"
                            id={productId}
                        >
                            <SimpleShowLayout>
                                <ThumbnailField size="large" source="images" />
                                <TextField source="name" fullWidth />
                                <RichTextField source="htmlDescription" />
                                <TextField source="weightInGrams" fullWidth />
                                <TextField source="widthInMtr" fullWidth />
                                <TextField source="lengthInMtr" fullWidth />
                                <TextField source="status" fullWidth />
                                <TextField source="mrp" fullWidth />
                                <TextField source="previewPdf" fullWidth />
                                <TextField source="pdfUrl" fullWidth />
                                <TextField source="validityInDays" fullWidth />
                            </SimpleShowLayout>
                        </Show>
                    </DataProviderContext.Provider>
                </div>
            ),
        },

        {
            label: 'Students',
            content: (
                    <AssignedUserList type="ebooks" typeId={params.productId} refreshKey={refreshKey} />              
            ),
        },
    ];
    return (
        <>
            <div className="flex justify-end mr-10 pt-5 pb-2">{isEbook &&
                <AssignEcomProductModal
                    type="ebooks"
                    typeId={params.productId}
                    title="Assign Product"
                    onSuccess={handleAssignSuccess}
                />
            }</div>
            <div className="border rounded-md mb-14">
                <div className="border-collapse flex text-lg flex-row gap-16 px-10 pt-4">
                    {tabData
                        .filter((_, index) => isEbook || index === 0) // Show only the first tab if not an eBook
                        .map((tab, index) => (
                            <div
                                key={index}
                                onClick={() => handleTabClick(index)}
                                className={`tab ${index === activeTab
                                    ? 'active text-[#4f3cc9] underline decoration-4 underline-offset-[20px]'
                                    : ''
                                    }`}
                            >
                                {tab.label}
                            </div>
                        ))}
                </div>
                <div className="tab-content">{tabData[activeTab]?.content}</div>
            </div>
        </>
    );
};

const Title = () => {
    const record = useRecordContext<Ecom_Products>();
    const translate = useTranslate();

    return record ? (
        <span>
            {translate('', { smart_count: 1 })} &quot;
            {record.name}
        </span>
    ) : null;
};

export default ProductShow;
